module.exports = __webpack_public_path__ + "img/menuboard_thai_express_large.dd8f3755.webp";